import React from 'react'
import { connect } from 'react-redux'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsUsrgItem from "./SetsUsrgItem"
import { isEmpty } from 'lodash'
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import SettingsForm from './SettingsForm'

class SetsUsrg extends SettingsForm {

  componentWillMount(){
    this.props.fetchSets('usrg');
    if (this.props.user_s) {
      this.props.fetchSets('org');
    }
    this.setState({
      adding: false,
      data: this.newItem,
      errors: {}
    });
  }

  modelName = 'usrg'

  newItem = {
    usrg_desc: '',
    usrg_org_id: 0,
    usrg_active: 1
  }

  render() {
    if(isEmpty(this.props.usrgs.data)
      || (this.props.user_s && isEmpty(this.props.orgs))
    ){
      return(<div>Не загружены данные</div>);
    }
    const {
      usrgs: {
        data: usrgs,
        search,
        sort
      },
      orgs,
      user_s
    } = this.props;
    const { data, errors } = this.state;

    var fltrUsrgs = [];
    for(var key in usrgs){
      if(usrgs.hasOwnProperty(key)){
        const active = usrgs[key].usrg_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + usrgs[key].usrg_desc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrUsrgs.push(usrgs[key]);
        }
      }
    }

    const srtUsrgs = fltrUsrgs.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.usrg_id < b.usrg_id)
         return sort.asc ? -1 : 1
      if(a.usrg_id > b.usrg_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedUsrgs = srtUsrgs ? srtUsrgs.map(usrg =>
      <SetsUsrgItem key={usrg.usrg_id}
        data={usrg}
        orgs={orgs}
        user_s={user_s}
      />
    ) : [];

    var orgsOpt = [];
    for (key in orgs){
      if(orgs.hasOwnProperty(key) && (orgs[key].org_active === 1
        || orgs[key].org_id === data.usrg_org_id)) {
        orgsOpt.push({value:orgs[key].org_id,label:orgs[key].org_desc});
      }
    }
    orgsOpt.sort(sortOpts);

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.usrg_desc}
              name="usrg_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        {!!user_s && (
          <td>
            <Select
              clearable={false}
              options={orgsOpt}
              value={data.usrg_org_id}
              onChange={e => this.updateSelect(e,'usrg_org_id')}
              placeholder="Организация"
            />
          </td>
        )}
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка групп услуг</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrUsrgs.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th className="col-sm-6" onClick={() => {this.handleSort('usrg_desc')}}>Название</th>
              {!!user_s && (
                <th className="col-sm-6" onClick={() => {this.handleSort('usrg_org_id')}}>Организация</th>
              )}
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedUsrgs}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
              {!!user_s && <td></td>}
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    usrgs: store.usrgs,
    orgs: store.orgs.data,
    user_s: store.auth.rights.user_s_post
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsUsrg);



// WEBPACK FOOTER //
// ./src/components/settings/SetsUsrg.js